export enum SortingType {
  Asc, Desc
}

export enum FilterValueType {
  Number, String, Date
}

export enum CriteriaOperator {
  Equal = '$f = $v',
  NotEqual = '$f != $v',
  Greater = '$f > $v',
  GreaterEqual = '$f >= $v',
  Lower = '$f < $v',
  LowerEqual = '$f <= $v',
  In = '$f In $v',
  Between = '$f Between ($v)',
  Contains = 'Contains($f, $v)',
  EndsWith = 'EndsWith($f, $v)',
  StartsWith = 'StartsWith($f, $v)',
  IsNullOrEmpty = 'IsNullOrEmpty($f) = True',
  IsNotNullOrEmpty = 'IsNullOrEmpty($f) = False',
  IsNull = 'IsNull($f) = True',
  IsNotNull = 'IsNull($f) = False',
  IsTrue = '$f = True',
  IsFalse = '$f = False',
  IsNullOrOid = '(IsNull($f) Or $f.Oid = $v)'
}

export enum TipoOrdinamentoTariffe {
  OrdinamentoTipoCameraTariffa,
  Prezzo,
  PrezzoDecrescente
}

export enum TipoServizio {
  Semplice,
  Composto,
  Pacchetto
}

export enum CalcoloPrezzoPacchetto {
  SingoloGiorno,
  GiornoArrivo,
  PrimoGiornoPacchetto
}

export enum TipoSupplemento {
  Persona = 1,
  Camera = 2
}

export enum TipoDettaglioProposta {
  Camera,
  SupplementoExtra,
  VoceLibera,
  Pax
}

export enum TipoArticolo {
  Nessuno = 0,
  Extra = 1,
  Trattamento = 3,
  Riduzione = 4,
  Supplemento = 5,
  ElementoTrattamento = 6
}

export enum TipoApplicazioneSupplemento {
  PrimoGiorno = 1,
  UltimoGiorno = 2,
  TuttiIGiorni = 3,
  NessunGiorno = 4
}

export enum TipoGrafico {
  Table,
  BarChart,
  PieChart,
  AreaChart,
  ColumnChart,
  LineChart
}

export enum TipoDatoWelcomeDashboard {
  Generale = 0,
  DataPrenotazione = 1,
  TipoCamera = 2,
  Trattamento = 3,
  Mercato = 4,
  CanaleVendita = 5,
  Nazione = 6,
  PoliticaCancellazione = 7,
  Sorgente = 8,
  BookingWindow = 9,
  BookingWindowCancellazione = 10,
  CrmGenerale = 100,
  CrmStato = 102,
  CrmMercato = 103,
  CrmCanaleVendita = 104,
  CrmCausaleRifiuto = 105,
}

export enum TipoDatoPrenotazioniDashboard {
  Mercato,
  CanaleVendita,
  Nazione,
  Provincia,
  PoliticaCancellazione,
  TipoPrenotazione,
  TipoCamera,
  Trattamento,
  Segmento,
  Fonte,
  Promozione,
  CodicePromozione
}

export enum TipoDatoPreventiviDashboard {
  Mercato,
  CanaleVendita,
  Nazione,
  Provincia,
  TipoRichiesta,
  TagCrm,
  Utente
}

export enum TipoDatoPreventiviPickup {
  Data,
  Mese,
  Mercato,
  CanaleVendita,
  Nazione,
  Provincia,
  TipoRichiesta,
  TagCrm,
  Utente
}

export enum TipoDatoPrenotazioniPickup {
  Data,
  Mese,
  Mercato,
  CanaleVendita,
  Nazione,
  Provincia,
  TipoPrenotazione,
  Trattamento,
  TipoCamera,
  Segmento,
  Fonte
}

export enum TipoDatoClientiProfilati {
  Mercato,
  CanaleVendita,
  Segmento,
  Fonte,
  Provincia,
  Nazione,
  Tipologia
}

export enum TipoDatoStorico {
  Data,
  Mese
}

export enum TipoValoreWelcomeDashboard {
  Prenotazioni,
  Pax,
  RoomNight,
  Revenue,
  ADR
}

export enum PercentualeSchermoWelcomeDashboard {
  Col2 = 2,
  Col3 = 3,
  Col6 = 6,
  Col9 = 9,
  Col12 = 12
}

export enum Sesso {
  M,
  F
}

export enum TipoAnagrafica {
  Cliente,
  Agenzia,
  Azienda
}

export enum TipoComponentePrenotazione {
  Adulto,
  Altro,
  Bambino,
  Enfant
}

export enum StatoPortaleXAlbergo {
  Aperto,
  Chiuso
}

export enum MealPlanType {
  RoomOnly,
  BB,
  HB,
  FB,
  AI
}

export enum StatoPubblicazionePortale {
  NonPubblicato,
  Pubblicato,
  ModificatoDaPubblicare,
  PubblicatoParzialmente
}

export enum TipoModificaDisponibilitaXPortaleXAlbergo {
  Nessuna,
  ManualeWelcome,
  ManualeWeb,
  BudgetVendita,
  DisponibilitaHotel,
  ChiusuraDisponibilitaHotel,
  BookingRules,
  BilanciamentoPrenotazione,
  ImportazionePrenotazione,
  CancellazionePrenotazione,
  WebApi,
  SbmApi 
}

export enum TipoPortale {
  Passepartout = 0,
  Venere = 1,
  Expedia = 2,
  BookingCom = 3,
  TravelEurope = 4,
  Itwg = 5,
  HotelDE = 6,
  RatesToGo = 7,
  MbeTravel = 8,
  InItalia = 9,
  Hrs = 10,
  HotelBeds = 11,
  Opera21 = 12,
  VerticalBooking = 13,
  BookingExpert = 14,
  Castelli = 15,
  BBLiverate = 16,
  BeGenius = 17,
  Escapio = 18,
  SimpleBooking = 19,
  Reservit = 20,
  SmithHotels = 21,
  //TripConnect = 23,
  VisitItaly = 24,
  ItalyHotels = 22,
  TheBestSpaHotels = 25,
  JDB = 27,
  BookingPiemonte = 28,
  JesoloOk = 29,
  DominaVipTravel = 30,
  Moena = 31,
  RiccioneBikeHotels = 32,
  AllInclusiveHotels = 33,
  DimoreEpoca = 61,
  SalentoIT = 72,
  SirmioneHotel = 76,
  ConsorzioSanMarino = 79,
  AiaPalas = 85,
  HotelEasyReservations = 34,
  BookingOne = 35,
  InItaliaDK = 36,
  Charming = 37,
  TurismoInToscana = 38,
  BedAndBreakfast = 39,
  GTATravel = 40,
  SalsaBooking = 41,
  Orbitz = 42,
  Lignano = 43,
  Tassoni = 44,
  Whl = 45,
  JesoloIT = 46,
  Inntopia = 47,
  WuBook = 48,
  HermesHotel = 49,
  BibioneComSitoCliente = 50,
  FastBooking = 51,
  WebHotelier = 52,
  LastMinuteCom = 53,
  ParityRate = 54,
  Hotusa = 55,
  RMS = 56,
  Iperbooking = 57,
  IperbookingPortal = 58,
  BibioneCom = 59,
  SocialBooking = 60,
  Seekda = 62,
  BBPlanet = 63,
  Xenia = 64,
  NaturalBooking = 65,
  HotelManagementBiz = 66,
  CampingItalia = 67,
  TurismoFVG = 68,
  Italcamel = 69,
  VisitTrentino = 70,
  MyGuestCare = 71,
  Hostelsclub = 73,
  MyReply = 74,
  ClickSuite = 75,
  AptLivigno_AlpineBits = 77,
  YesAlps_AlpineBits = 78,
  HotelBookingSky = 80,
  Eurobedsit = 81,
  Bolognawelcome = 82,
  BookingEngineR2BookingExpert = 83,
  Vivafirenzeit = 84,
  Siteminder = 86,
  IperbookingPortalV2 = 87,
  WebBookingPass = 88,
  Sireontours = 89,
  UnoDueTreBook = 90,
  Favouritaly = 91,
  Cisalpinatours = 92,
  PiccoliAlberghi = 93,
  SabreSynxis = 94,
  BeMyGuest = 95,
  Master = 100,
  RoomCloud = 101,
  Agoda = 102,
  DayBreakHotels = 103,
  OneUpTravel = 104,
  BestHolidaysInItaly = 105,
  Aves = 106,
  Hyperguest = 107,
  HotelTonight = 108,
  TripCom = 109,
  YieldPlanet = 110,
  NetStorming = 111,
  OpenGDS = 112,
  AirBnb = 113,
  Italieonline = 114,
  BookVisit = 115,
  SecureHoliday = 116
}

export enum TipoAnalytics {
  GoogleAnalytics,
  GoogleUniversalAnalytics,
  GoogleTagManager,
  GoogleUniversalAnalyticsPersonalizzato
}

export enum TipoBilanciamentoInterno {
  TariffaVendutaTipologiaCameraVenduta,
  TariffaVendutaTutteLeTipologieCamera,
  TutteLeTariffeTipologiaCameraVenduta,
  TutteLeTariffeTutteLeTipologieCamera,
  Listino,
  TutteLeTariffeTipoCameraHotel
}

export enum StatoPrenotazione {
  Nessuno,
  InAttesa,
  Confermata,
  Rifiutata,
  CancellazioneRichiesta,
  Trasferita
}

export enum StatoUpSelling {
  Nessuno,
  InAttesa,
  Confermata,
  Rifiutata
}

export enum StatoPrenotazioneWelcome {
  Prenotata,
  Confermata,
  WaitingList,
  Opzionata,
  Richiesta,
  NoShow,
  ContoAperto,
  ContoChiuso,
  Eliminata
}

export enum TipoVisualizzazioneGrigliaDisponibilita {
  Mai,
  SenzaDisponibilita
}

export enum TipologiaAlbergo {
  Hotel,
  Residence,
  HotelResidence,
  Appartamenti,
  Chalet,
  Ostello
}

export enum StelleAlbergo {
  Nessuna = 6,
  Una = 0,
  Due = 1,
  Tre = 2,
  TreS = 3,
  Quattro = 4,
  Cinque = 5,
  Residence = 7,
  Appartamenti = 8,
  CaseVacanze = 9,
  AffittaCamere = 10,
  BB = 11
}

export enum StelleAlbergoString {
  Nessuna = '',
  Una = '*',
  Due = '**',
  Tre = '***',
  TreS = '***',
  Quattro = '****',
  Cinque = '*****',
  Residence = '',
  Appartamenti = '',
  CaseVacanze = '',
  AffittaCamere = '',
  BB = ''
}

export enum TipoValore {
  Euro,
  Percentuale
}

export enum Pagina {
  Booking,
  Richiesta,
  MyPage,
  MySelf,
  Paymail,
  MySelfMobile,
  Sondaggio,
  BookingV2
}

export enum HtmlElement {
  Body,
  H1,
  H2,
  H3,
  H4,
  H5,
  H6,
  Label,
  P,
  Button
}

export enum StatoCtaCtd {
  Aperto,
  Chiuso
}

export enum Header {
  Sbm,
  Dms
}

export enum TipoModalitaPagamento {
  CartaCredito = 1,
  BonificoBancario = 2,
  VagliaPostale = 3,
  BankPass = 4,
  BankPassSIS = 5,
  CartaSi = 6,
  BancaSellaOTP = 7,
  BancaSella = 8,
  PayPal = 9,
  PagamentoInHotel = 10,
  XPay = 11,
  PayWay = 12,
  Unicredit = 13,
  Satispay = 14,
  Stripe = 15,
  AddonPayments = 16,
  BeSafePay = 17,
  SumUp = 18,
  Hobex = 19,
  Axepta = 20,
  Holipay = 21,
  Siapay = 22,
  ScalaPay = 23,
  VirtualPay = 24,
  MyPOS = 25,
  VivaWallet = 26,
  TPay = 27
}

export enum TipoContabilizzazione {
  Immediata,
  Differita
}

export enum StatoContabilizzazione {
  Nessuno,
  Contabilizzato,
  Rimborsato,
  Annullato
}

export enum Ruolo {
  Administrator = 0,
  User = 1,
  Governante = 2,
  Cameriere = 3,
  ExtraBar = 4,
  Web = 5,
  Manutentore = 6,
  FrontOffice = 7,
  SuperAdmin = 100
}

export enum TipoVisualizzazioneImmagine {
  Immagine,
  ImmagineFullWidth
}

export enum TipoImmaginePortale {
  Sfondo,
  SfondoBookingExtra,
  Struttura,
  Logo,
  LogoMobile,
  Favicon
}

export enum TipoImmagineUbicazioneIstat {
  Sfondo,
  HeaderMySelf
}

export enum TipoImmaginePromozione {
  Immagine,
  ImmagineEvidenza
}

export enum TipoImmagineAlbergoMaster {
  Top,
  Bottom
}

export enum TipoImmaginePortaleAdmin {
  Logo,
  Icona
}

export enum TipoPromozione {
  Sconto,
  NumeroComponenti,
  PianoFamiglia,
  PianoFamigliaXComponenti,
  PrenotaPrima
}

export enum TipoBloccoHtml {
  Home,
  ElencoDisponibilita,
  ElencoDisponibilitaFine,
  PannelloRicercaPeriodo,
  PannelloRicercaPeriodoFine,
  PopupHome,
  AsideHome
}

export enum TestoMyPage {
  TestoEmail = 0,
  TestoIniziale = 1,
  TestoPrimaProposte = 2,
  TestoDopoProposte = 3,
  TestoFinale = 4,
  TestoInizialeMyPageAccettato = 5,
  TestoFinaleMyPageAccettato = 6,
  TestoInizialeMyPagePrenotato = 7,
  TestoFinaleMyPagePrenotato = 8,
  TestoUpSelling = 9,
  TestoWhatsAppSms = 10,
  TestoIniziale2 = 11,
  TestoWhatsAppSmsAccettato = 12,
  TestoWhatsAppSmsPrenotato = 13,
  TestoInizialeMyPagePrenotatoInAttesaPagamento = 14,
  TestoFinaleMyPagePrenotatoInAttesaPagamento = 15
}

export enum TestoMySelf {
  TestoIniziale,
  TestoIniziale2
}

export enum StatoPreventivo {
  Nuovo,
  Bozza,
  DaGestire,
  Inviato,
  Visualizzato,
  Scaduto,
  Accettato,
  InAttesaPagamento,
  Prenotato,
  Cancellato,
  Rifiutato,
  Opzionato,
  ReCall1,
  ReCall2,
  Archiviato = 100
}

/*export enum StatoMyPage {
    Nessuno,
    Visualizzato,
    Accettato,
    InAttesaPagamento,
    Prenotato,
    Cancellato
}*/

export enum TipoEsitoOperazionePortaleXAlbergo {
  NessunErrore,
  ErroreConnessioneDatabase,
  AlbergoInesistente,
  ErroreParametroDiInputNonCorretto,
  ErroreParametroDiInputMancante,
  ErroreGenerico,
  ErroreOTA
}

export enum TipoOperazionePortaleXAlbergo {
  GetCamere = 0,
  GetTariffe = 1,
  SetDisponibilita = 2,
  GetPrenotazioni = 3,
  ConfermaSalvataggioPrenotazioni = 4,
  GetCartaCredito = 5,
  GetPrenotazioniModificateCancellate = 6,
  ConfermaModificaCancellazionePrenotazioni = 7,
  CreaAggiornaCamera = 8,
  EliminaCamera = 9,
  CreaAggiornaCategoriaCamera = 10,
  EliminaCategoriaCamera = 11,
  GetCategorieCamere = 12,
  ModificaPassword = 13,
  GetHotels = 14,
  SalvaCartaCredito = 15,
  CancellaResCCNonValida = 16,
  CCNonValida = 17,
  NoShow = 18,
  RecuperaPrenotazioni = 19,
  CreaAggiornaTariffa = 20,
  EliminaTariffa = 21,
  LeggiPrenotazioniBulk = 22,
  PubblicaPrenotazioniWelcome = 23,
  PubblicaDisponibilitaWelcome = 24,
  ChiudiDisponibilitaWelcome = 25,
  WebApiBooking = 26,
  WebApiAvailabilityRequest = 27,
  WebApiUpdatePrice = 28,
  TrivagoEBBookingAvailability = 29,
  TrivagoEBBookingSubmit = 30,
  GetErroriPortale = 31,
  TestConnection = 32,
  SbmApiWelcomeUpdate = 100,
  SbmApiPublic = 101,
  SbmApiCrmWeb = 102,
  SbmApiCreaRichiesta = 103,
  SbmApiCreaTransazione = 104,
  SbmApiWebHooks = 105,
  SbmApiWorkFlow = 106,
  SbmConfigurazione = 107,
  SbmInvioMail = 108,
  SbmPlugin = 109,
  SbmApiCheckInOnLine = 110
}

export enum TipoTemplate {
  Generico = 0,
  Cliente = 1,
  Prenotazione = 2,
  PrenotazioneConfermata = 3,
  PrenotazioneRifiutata = 4,
  PrenotazioneContenuto = 5,
  CheckinOnlineEseguito = 6,
  PrenotazioneECommmerce = 7,
  MessaggioCliente = 8,
  RichiestaRifiutata = 9,
  Preventivo = 10,
  PreventivoAccettato = 11,
  PreventivoRifiutato = 12,
  PreventivoContenuto = 13,
  PreventivoRichiestaCaparra = 14,
  PreventivoPrenotato = 15,
  PreventivoRinnovaRichiesta = 16,
  MessaggioHotel = 17,
  Sondaggio = 20,
  RichiestaDisponibilitaHotel = 30,
  RichiestaDisponibilitaCliente = 31,
  Promozione = 40,
  CodicePromozione = 41,
  Voucher = 42,
  Banner = 43,
  PrenotazioneUpSelling = 44,
  PayMail = 45,
  PrenotazioneUpSellingArticoli = 46,
  PayMailPagato = 47,
  TrasferimentoPrenotazioni = 48,
  PrenotazioneRoomServiceArticoli = 49,
  RispostaPostaCrm = 50,
  RegistrazioneCliente = 51,
  BuonoRegaloPrenotazioneECommmerce = 53,
  RicercaBookingEngine = 54,
  EmissioneBuonoSconto = 55,
  PrenotazioneAccessori = 56,
  EmailNotifichePortali = 100,
  RecuperaPassword = 101
}

export enum TipoWorkFlow {
  Richieste,
  Preventivi,
  Prenotazioni,
  Pagamenti,
  Sondaggi,
  CreazionePreventivo
}

export enum TipoBookingRules {
  Prenotazioni,
  Cancellazioni
}

export enum TipoDocumento {
  CartaIdentita = 0,
  Passaporto = 1,
  Patente = 2,
  CartaIdentitaElettronica = 3
}

export enum EnteRilascioDocumento {
  Comune = 0,
  Questura = 1,
  Prefetto = 2
}

export enum TipoVisualizzazioneTariffe {
  TariffaPromozioni,
  SoloPromozioni,
  SoloPromozioni_TariffaSePromozioniNonValide
}

export enum TipoArrotondamento {
  Matematico,
  Superiore,
  Inferiore
}

export enum TipoPenaleCancellazione {
  Percentuale,
  NumeroNotti
}

export enum ModalitaCalcoloPrezzo {
  Nessuno = 0,
  FissaGiornaliera = 1,
  FissaPerData = 2,
  QuotaVariabile = 3,
  Consumo = 4,
  UltimaNotte = 5,
  GiornoCambioBiancheria = 6,
  ConsumoGiornaliero = 7,
  PrimoGiorno = 8,
  Tassa = 9,
  ScontoFisso = 10,
  NumeroGiorno = 13,
  PrimoGiornoPacchetto = 15
}

export enum TipoDisponibilitaArticolo {
  NonDisponibile,
  DisponibilePrezzoCompreso,
  DisponibilePrezzoNonCompreso,
  DisponibilePrezzoNonCompresoStep1
}

export enum TipoProduzioneXComponenteXPrenotazione {
  Produzione,
  Supplemento,
  ExtraAutomatico
}

export enum MittenteMessaggio {
  Hotel,
  Cliente
}

export enum TipoListino {
  Persona = 1,
  Camera = 2,
  ArticoliExtra = 4
}

export enum TipoCodicePromozione {
  CodiceSconto,
  Voucher
}

export enum TipoPrenotazioneExtra {
  ECommerce,
  UpSelling,
  RoomService,
  BuonoSconto,
  ReplicaDati,
  Accessori,
  Appuntamento
}

export enum TipoPermesso {
  //Myforecast = 0,
  AlberghiPartner = 1,
  Alberghi = 2,
  ConfigurazioneDmsAdmin = 3,
  PortaliAdmin = 4,
  MessaggiAdmin = 5,
  TemplatesAdmin = 6,
  ServiziAdmin = 7,
  ApiKeysAdmin = 8,
  AttivitaAutomaticheAdmin = 9,
  Tutorial = 10,
  SondaggiAdmin = 11,
  SmartCloud = 12,
  Planning = 13,
  PlanningTipoCamera = 14,
  CalendarioPrezzi = 15,
  ElencoDisponibilita = 16,
  RateChecker = 17,
  CalcolaRetta = 18,
  Richieste = 19,
  Preventivi = 20,
  Messaggi = 21,
  Sondaggi = 22,
  RisposteSondaggi = 23,
  PickupPreventivi = 24,
  Pickup = 25,
  Prenotazioni = 26,
  ECommerce = 27,
  ChiusureGiornaliere = 28,
  Clienti = 29,
  Transazioni = 30,
  Ricerche = 31,
  Storico = 32,
  Report = 33,
  LogOperazioni = 34,
  LogDisponibilita = 35,
  NotificheEmail = 36,
  ImpostazioniAlbergo = 37,
  Portali = 38,
  ConfigurazioneDms = 39,
  ConfigurazioneMyPage = 40,
  ConfigurazioneBooking = 41,
  Servizi = 42,
  Cancellazioni = 43,
  ModalitaPagamento = 44,
  Promozioni = 45,
  CodiciPromozionali = 46,
  Banner = 47,
  UpSelling = 48,
  TagCrm = 49,
  Templates = 50,
  Sistemazioni = 51,
  Agenzie = 52,
  Utenti = 53,
  ApiKeys = 54,
  AttivitaAutomatiche = 55,
  Interessi = 56,
  ParametriRicerca = 57,
  AccountMail = 58,
  WebHooks = 59,
  CollegamentoSito = 60,
  WorkFlows = 61,
  TipiCamera = 62,
  Trattamenti = 63,
  Riduzioni = 64,
  CombinazioniRiduzioni = 65,
  Supplementi = 66,
  Articoli = 67,
  ServiziObbligatori = 68,
  Listini = 69,
  Arrotondamenti = 70,
  VociAddebito = 71,
  CausaliOperazione = 72,
  TipiCliente = 73,
  Eventi = 74,
  PubblicazioneDisponibilita = 75,
  ModificaBlocchiPlanning = 76,
  ModificaDisponibiliPlanning = 77,
  ModificaPrezzoPlanning = 78,
  ModificaStatoCtaCtdPlanning = 79,
  ModificaStatoPortalePlanning = 80,
  ModificaMinMaxStayPlanning = 81,
  ModificaFasceCalendario = 82,
  EliminazioneDisponibilita = 83,
  EliminazionePrenotazione = 84,
  PrenotazionePreventivo = 85,
  EliminazionePreventivo = 86,
  Trentino = 87,
  TutorialList = 88,
  ClientiProfilati = 89,
  Qualitelis = 90,
  UpSellingRichiesti = 91,
  ConfigurazioneMySelf = 92,
  InviaSms = 93,
  LogAccessi = 94,
  Scrollidea = 95,
  ConfigurazionePaymail = 96,
  PianiTariffari = 97,
  BookingRules = 98,
  CopiaTariffe = 99,
  TrustYou = 100,
  Nazioni = 101,
  Comuni = 102,
  Mailchimp = 103,
  ActiveCampaign = 104,
  HubSpot = 105,
  InserimentoScontiCrm = 106,
  ContabilizzazioneStorno = 107,
  VisualizzazioneImportiStatiPreventivi = 108,
  StoricoAdmin = 109,
  PrenotazioniRicevute = 110,
  ErroriPortali = 111,
  PlanningMaster = 112,
  PhilipsCMND = 113,
  Manuale = 114,
  ModificaVariazioneDisponibiliPlanning = 115,
  //Hoau = 116,
  ModificaAllegati = 117,
  MotiviViaggio = 118,
  LogApiKeys = 119,
  ImportaPrenotazioni = 120,
  VisualizzazioneNumeroPreventiviPrenotazioni = 121,
  ConfigurazionePagineMySelf = 122,
  ConfigurazionePiattiMySelf = 123,
  ConfigurazioneArticoliMySelf = 124,
  EliminazioneTransazioni = 125,
  ConfigurazioneImpostazioniMySelf = 126,
  ConfigurazioneMySelfMobile = 127,
  ConfigurazioneMenuMySelf = 128,
  CalendarioMenu = 129,
  UbicazioniIstat = 130,
  ConfigurazioneCrs = 131,
  PrenotazioniCrs = 132,
  DisponibilitaCrs = 133,
  ConfigurazioneCategoriePiattiMySelf = 134,
  TrasferimentoPrenotazioniCrs = 135,
  ConteggioPiatti = 136,
  RoomService = 137,
  PrenotazioniUpSelling = 138,
  ConfigurazioneFormRichiesta = 139,
  PostaCrm = 140,
  ModificaPreventivoInviato = 141,
  TagsTemplates = 142,
  ChangeLogs = 143,
  ChangeLog = 144,
  ModificaModalitaPagamentoPrenotazione = 145,
  StatoPubblicazionePortali = 146,
  UpgradeGratuiti = 147,
  ConfigurazioneSondaggio = 148,
  EsportazionePrenotazioni = 149,
  VisualizzazioneDatiEconomiciDashboard = 150,
  VisualizzazioneDatiEconomiciPrenotazioni = 151,
  ImpostaPrenotazioneComeImportataManualmente = 152,
  EliminazioneAnagrafiche = 153,
  VisualizzazioneChiusureGiornaliereDashboard = 154,
  Risorse = 155,
  AttivaFlagCalcolaRetta = 156,
  PersonalizzaDashboard = 157,
  ModificaPrezzoBasePlanning = 158,
  GiorniChiusura = 159,
  QuadriGrafici = 160,
  EliminazioneDefinitivaPreventivo = 161,
  ImpostaPrenotazioneComeDaImportareManualmente = 162
}

export enum TipoApiKey {
  PublicAPI = 0,
  LetturaPrezzi = 1,
  TrentinoGuestCard = 2,
  //MyForecast = 3,
  SmsHosting = 4,
  Qualitelis = 5,
  Twilio = 6,
  ImportazionePrenotazioni = 7,
  Scrollidea = 8,
  TrustYou = 9,
  ActiveCampaign = 10,
  Mailchimp = 11,
  HubSpot = 12,
  PhilipsCMND = 13,
  //Hoau = 14,
  InfoAlberghi = 15,
  TokyDigital = 16,
  AdSms = 17
}

export enum TipoRichiestaPreventivo {
  Diretto,
  Email,
  Telefono,
  Web,
  WhatsApp
}

export enum TipoNotificaEmail {
  Prenotazione = 100,
  Preventivo = 101,
  AutomatismoPreventivo = 110,
  AutomatismoPrenotazione = 111
}

export enum TipoFiltroDashboard {
  Personalizzato,
  Oggi,
  Ieri,
  UltimaSettimana,
  QuestoMese,
  Ultimi30Giorni,
  Ultimi90Giorni,
  AnnoCorrente
}

export enum TipoFiltroPreventivi {
  Nessuno,
  Oggi,
  UltimaSettimana,
  QuestoMese,
  AnnoCorrente,
  AnnoPrecedente,
  AnnoSuccessivo
}

export enum TipoFiltroPrenotazioni {
  Personalizzato,
  Oggi,
  Domani,
  Prossimi7Giorni,
  Prossimi30Giorni,
  AnnoCorrente
}

export enum FlagPreventivo {
  Nessuno,
  Rosso,
  Verde,
  Giallo
}

export enum FlagRichiesta {
  Nessuno,
  Rosso,
  Verde,
  Giallo
}

export enum MenuCategory {
  Configurazione,
  Statistiche,
  Web,
  Crm
}

export enum TipoCartaCredito {
  Visa = 0,
  AmericanExpress = 1,
  MasterCard = 2,
  DiscoveryCard = 3,
  DinersClub = 4,
  JCB = 5,
  EuroCard = 6,
  BankCard = 7,
  CarteBlanche = 8,
  CarteBleu = 9,
  UniversalAir = 10,
  Maestro = 11,
  EnRoute = 12,
  AccessCard = 12,
  BankAmeriCard = 13,
  ChinaUnionPay = 14,
  Dankort = 15,
  DinersClub_USACanada = 16,
  InstaPayment = 17,
  Laser = 18,
  VisaElectron = 19,
  Sconosciuto = 1000
}

export enum TipoParametroRicerca {
  Mercato,
  CanaleVendita,
  UltimoPeriodoSoggiorno,
  PersonalizzatoCliente,
  PersonalizzatoAgenzia,
  Segmento,
  Fonte
}

export enum TipoDomandaSondaggio {
  Checkbox,
  Radio,
  Text,
  Date,
  Email,
  VotoStelle,
  VotoFaccine,
  SiNo
}

export enum SslProtocols {
  None = 0,
  Ssl2 = 12,
  Ssl3 = 48,
  Tls = 192,
  Default = 240,
  Tls11 = 768,
  Tls12 = 3072
}

export enum SecureSocketOptions {
  None = 0,
  Auto = 1,
  SslOnConnect = 2,
  StartTls = 3,
  StartTlsWhenAvailable = 4
}

export enum StatoSondaggio {
  Visualizzato,
  Compilato
}

export enum StatoEsecuzioneTransazione {
  Eseguito,
  NonEseguito,
  Errore,
  Annullato
}

export enum TipoPrenotazioneXPay {
  GARANTITA,
  NONRIMBORSABILE,
  RIMBORSABILE,
  PREAUTH,
  GARANTITAPENALE
}

export enum FonteRecensione {
  Nessuna,
  Booking,
  Tripadvisor,
  Google,
  HolidayCheck
}

export enum ImmagineFonteRecensione {
  Nessuna = "",
  Booking = "/assets/images/booking/fonti-recensione/booking.png",
  Tripadvisor = "/assets/images/booking/fonti-recensione/tripadvisor.png",
  Google = "/assets/images/booking/fonti-recensione/google.png",
  HolidayCheck = "/assets/images/booking/fonti-recensione/holidaycheck.png"
}

export enum CategoriaServizio {
  Tutte,
  Hotel,
  Camera,
  Tariffa
}

export enum GiornoSettimana {
  Domenica,
  Lunedi,
  Martedi,
  Mercoledi,
  Giovedi,
  Venerdi,
  Sabato
}

export enum StatoMyForecast {
  InAttesaDiAttivazione,
  Attivo
}

export enum TipoOperazioneWebHooks {
  CreaCliente,
  ModificaCliente,
  EliminaCliente,
  CreaPrenotazione,
  ModificaPrenotazione,
  EliminaPrenotazione
}

export enum CampoFiltroWorkFlow {
  Nessuno,
  DataRichiesta,
  DataInvioPreventivo,
  Arrivo,
  Partenza,
  DataScadenza,
  DataScadenzaAccontoCaparra,
  DataConfermaPreventivo,
  DataCreazione,
  ArrivoMinoreUguale,
  DataCancellazione,
  DataCaparra,
  DataModificaWelcome
}

export enum CondizioneCampoFiltroWorkFlow {
  GiorniPrima,
  GiorniDopo
}

export enum StatoRoomingList {
  Nessuno,
  Visualizzata,
  Completata,
  Cancellata
}

export enum TipoPasto {
  Colazione = 1,
  Pranzo = 2,
  Cena = 3
}

export enum TipoPrenotazione {
  PMS,
  WebBooking,
  OTA,
  CRM,
  API
}

export enum TipoCausaleOperazione {
  Generica = 0,
  CancellazionePrenotazione = 1,
  RichiestaRifiutata = 2,
  PreventivoRifiutato = 3,
  CancellazionePreventivo = 4
}

export enum TipoModificaPlanningCamera {
  Disponibili,
  DurataMinimaSoggiorno,
  DurataMassimaSoggiorno,
  Stato,
  Fascia,
  PrezzoBase
}

export enum VersioneMyPage {
  Versione1,
  Versione2
}

export enum VersioneSelfCheckIn {
  Versione1,
  Versione2
}

export enum VersioneBooking {
  Versione1,
  Versione2
}

export enum ModelloPrezzo {
  Normale,
  DerivedPrices
}

export enum CampoObbligatorioFormRichiesta {
  Cellulare,
  TipoRichiesta,
  Mercato,
  CanaleVendita,
  Nazione,
  Note,
  TipoCamera,
  Tariffa,
  MotivoViaggio,
  Nome
}

export enum CampoObbligatorioMyPage {
  Cellulare,
  Sistemazione,
  Nazione
}

export enum CampoObbligatorioBooking {
  Richieste,
  OraArrivo,
  Sistemazione,
  Nazione,
  Cellulare
}

export enum CampoObbligatorioECommerce {
  Cellulare
}

export enum CampoObbligatorioSelfCheckIn {
  OraArrivo,
  Allegato
}

export enum TipoVisualizzazioneBanner {
  PrimaDelleTariffe,
  Finestra,
  InBassoASinistra
}

export enum ListaSelfCheckIn {
  Prenotazioni,
  Richieste,
  Voucher,
  Recensioni
}

export enum ImportoPayMail {
  TotaleSoggiorno,
  Caparra,
  PrimaNotte,
  DueNotti,
  PenaleCancellazione,
  TotaleTassaSoggiorno
}

export enum TipoRisorsa {
  Camera,
  Sala,
  Accessori
}

export enum TipoLogAccesso {
  Nessuno,
  AmministrazioneWeb,
  ServizioWindows,
  CustomerArea,
  Sbm
}

export enum TipoErroreLogAccesso {
  Nessuno,
  UtentePasswordErrati,
  SogliaErroriSuperata
}

export enum TipoErroreLogPortale {
  PubblicaDisponibilita,
  PubblicaDisponibilitaPerAttivitàAutomatica,
  CreaModificaPrenotazioneWS
}

export enum TipoPaginaDms {
  Testo,
  Link
}

export enum SezioneTraduzioni {
  Booking,
  BookingDayUse,
  PagamentoForm,
  FormRichiesta,
  MyPage,
  Paymail,
  MySelf,
  SondaggioForm,
  Generiche
}

export enum TipoStoricoCliente {
  Richiesta,
  Preventivo,
  Prenotazione
}

export enum LettereMaiuscole {
  Nessuna,
  Iniziale,
  TuttoMaiuscolo
}

export enum TipoPaginaMySelf {
  Pagina,
  Link
}

export enum TipoEsitoSbm {
  NessunErrore,
  ErroreConnessioneDatabase,
  AlbergoInesistente,
  ErroreParametroDiInputNonCorretto,
  ErroreParametroDiInputMancante,
  ErroreGenerico,
  ErroreOTA,
  PortaleInesistente
}

export enum ModalitaSceltaMenuMySelf {
  GiornoSuccessivo,
  TuttiIGiorni
}

export enum CategoriaAllergene {
  Nessuno,
  Glutine,
  Crostacei,
  Uova,
  Pesce,
  Arachidi,
  Soia,
  Latte,
  FruttaAGuscio,
  Sedano,
  Senape,
  Sesamo,
  AnidrideSolforosa,
  Lupini,
  Molluschi,
  Surgelati,
  Congelati,
  Abbattuti,
  ProteineDelLatte,
  Coloranti,
  Pectina
}

export enum TipoPropagazionePreventivi {
  TutteLeProposte,
  TutteLeProposteDiTutteLeCamere
}

export enum TipoScontoProposta {
  Sconto,
  Arrotondamento
}

export enum TipoApplicazionePromozione {
  Entrambi,
  SoloWeb,
  SoloCrm
}

export enum VisualizzaPrenotazioniCentroPrenotazioni {
  Tutte,
  DaTrasferire,
  Trasferite
}

export enum TipoParametroPortale {
  NonGestito = 0,
  NonImplementato = 2,
  AttivoSempre = 3,
  AttivoConFlag = 4
}

export enum TipoPubblicazioneDisponibilitaWelcomeWS {
  Sincrona,
  Asincrona,
  LambdaAWS,
  Disattivata = 100
}

export enum TipoVisualizzazioneImmaginePrenotazione {
  Mai,
  camera,
  Struttura
}

export enum PaginaMessaggioCliente {
  MyPage,
  PayMail,
  MySelf,
  SelfCheckin
}

export enum TipoLogSBM {
  Nessuno,
  SqlServerDB,
  MongoDB
}

export enum ModalitaModificaDisponibilitaXPortaleXAlbergo {
  Diretta,
  CreatoModificatoDaMaster
}

export enum VersioneSbm {
  Nessuna = 0,
  Locale = 1,
  Staging = 2,
  Produzione = 3,
  LocaleAPI = 101,
  StagingSbmAPI = 102,
  ProduzioneSbmAPI = 103
}

export enum TipoModificaStatoPortaliCollegati {
  ChiudiEBlocca = 0,
  ChiudiSenzaBloccare = 1,
  Apri = 2,
  ApriNonBloccati = 3
}

export enum ModalitaSelezioneTariffaWorkFlowCreazionePreventivo {
  MaggioreDisponibilita = 0,
  PrezzoPiuBasso = 1
}

export enum TipoImmagineTagCrm {
  Header,
  Sfondo
}

export enum ModelloAutomatismo {
  //Prenotazioni
  UnGiornoDopoCreazionePrenotazione,
  RecallCaparra,
  RicevutaCaparra,
  InvitoCheckIn,
  Disdetta,
  ComunicazionePostStay,
  ReminderArrivo,

  //Preventivi
  RecallPreventivoScaduto,
  RecallPreventivoInviato,
  RecallPreventivoVisualizzato,
  ReminderScadenzaCaparra
}

export enum TipoOrdinamentoRichiestePreventivi {
  DataCreazioneCrescente,
  ArrivoCrescente,
  DataCreazioneDecrescente,
  ArrivoDecrescente
}

export enum ValiditaOffertaPeriodo {
  TuttiIGiorni,
  AlmenoUnGiorno
}

export enum TipoInvioEmail {
  Nessuno,
  Hotel,
  Cliente,
  Entrambi
}

export enum SezioneDashboard {
  Disponibilita,
  Prenotazioni,
  Messaggi,
  NotificheEmail,
  ChiusureGiornaliere
}